module.exports = __webpack_public_path__ + "static/media/svg-5.d9e440a5.svg";